import styled from "styled-components";
import { theme } from "../theme/toyotaTheme";
import * as Button from "../components/Button";

export const Wrapper = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: flex-end;
    row-gap: ${theme.space[3]}px;
    width: 100%;
    max-width: 400px;

    ${Button.Primary},
    ${/* sc-selector */ Button.Secondary},
    ${Button.PrimaryWhite} {
        width: 195px;
    }
`;
